export default __webpack_public_path__ + "static/benefitImg-255fc09573b1d2f248cc7bc880205425.png";